import { render, staticRenderFns } from "./intelligentGuidancePhone.vue?vue&type=template&id=57529137&scoped=true"
import script from "./intelligentGuidancePhone.vue?vue&type=script&lang=js"
export * from "./intelligentGuidancePhone.vue?vue&type=script&lang=js"
import style0 from "./intelligentGuidancePhone.vue?vue&type=style&index=0&id=57529137&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57529137",
  null
  
)

export default component.exports